/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';
import { CacheManager } from './cache-manager';

/**
 * Icon
 */
class Shell extends Component {
  static propTypes = {
    prefix: PropTypes.string,
    rtl: PropTypes.bool,
    /**
     * 指定显示哪种图标
     */
    type: PropTypes.string,
    /**
     * 指定图标大小
     */
    size: PropTypes.oneOf(['xs', 'small', 'medium', 'large', 'xl', 'xxl', 'xxxl']),
    className: PropTypes.string,
  };

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
  };

  render() {
    /* eslint-disable no-unused-vars */
    const { prefix, type, size, className, rtl, children } = this.props;
    const other = obj.pickOthers(Shell.propTypes, this.props);
    const classes = cls({
      [`${prefix}icon`]: true,
      [`${prefix}icon-${type}`]: !!type,
      [`${prefix}${size}`]: !!size,
      [className]: !!className,
    });

    if (
      rtl &&
      [
        'chevron-left',
        'chevron-right',
        'chevrons-left',
        'chevrons-right',
        'arrows-swtich-horizontal',
        'arrows-swtich-vertical',
        'arrows-long-down',
        'arrows-long-up',
      ].indexOf(type) !== -1
    ) {
      other.dir = 'rtl';
    }

    return (
      <i {...other} className={classes}>
        {children}
      </i>
    );
  }
}

const alternatives = new Map();
function searchAlternative(ns, type) {
  const pre = alternatives.get(ns + type);
  if (typeof pre === 'boolean') {
    return pre;
  }
  const lib = window && window.___iconfont;
  if (!lib) {
    return false;
  }
  const space = lib[ns];
  if (!Array.isArray(space)) {
    return false;
  }
  const ret = lib[ns].indexOf(type) > -1;
  alternatives.set(ns + type, ret);
  return ret;
}

function create(options = {}) {
  class Iconfont extends React.Component {
    static displayName = 'Iconfont';

    constructor(props) {
      super(props);
      let scriptUrl = options.scriptUrl || props.scriptUrl;
      const defaultUrl = '//at.alicdn.com/t/a/font_1310450_flm0x1py0b.js';

      // 是否使用自定义的图标库
      const useCustomUrl = scriptUrl && scriptUrl !== defaultUrl;

      // 使用自定义图标库 或 非离线场景时发送请求
      if (useCustomUrl || !process.env.OFFLINE) {
        scriptUrl = scriptUrl || defaultUrl;
        if (
          typeof document !== 'undefined' &&
          typeof window !== 'undefined' &&
          typeof document.createElement === 'function' &&
          typeof scriptUrl === 'string' &&
          scriptUrl.length &&
          !CacheManager.has(scriptUrl)
        ) {
          const script = document.createElement('script');
          script.setAttribute('src', scriptUrl);
          script.setAttribute('data-namespace', scriptUrl);
          script.setAttribute('async', true);
          CacheManager.add(scriptUrl);
          document.body.appendChild(script);
        }
      }

      // 离线场景默认加载本地图标库
      // 目前只支持 npm 引入方式，要开启离线模式，请在 webpack 中设置 process.env.OFFLINE 为 true
      // todo(zehao): 支持构建 offline 版本的 bundle
      if (process.env.OFFLINE) {
        // _remote-font 文件通过构建脚本下载
        // ref: scripts/download-icon-font.sh
        require('./_remote-font');
      }
    }

    render() {
      const { symbolPrefix, alternative } = options;
      const { type, children, ...restProps } = this.props;
      let content = null;
      if (alternative && searchAlternative(alternative, type)) {
        content = <use xlinkHref={`#${alternative}${type}`} />;
      } else if (type) {
        content = <use xlinkHref={`#${symbolPrefix}${type}`} />;
      }

      return (
        <Shell
          type={type}
          {...restProps}
          className={cls({
            [restProps.className]: !!restProps.className,
          })}
        >
          <svg viewBox="0 0 1024 1024">{content}</svg>
        </Shell>
      );
    }
  }

  return Iconfont;
}

const Icon = create({
  symbolPrefix: 'at-',
  alternative: 'tb-',
});

Icon._typeMark = 'icon';

Icon.createFromIconfont = create;

export default ConfigProvider.config(Icon);
